/* eslint-disable react/no-unknown-property */
import React from 'react';
import PageLayout from 'components/Layouts/PageLayout/PageLayout';
import ServiceUnavailable from 'components/Layouts/ServiceUnavailable/ServiceUnavailable';
import { useAppSelector } from 'hooks';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { ServiceCode } from 'store/user/types/service';

const LoadbalancerLayout = () => {
  const [t] = useTranslation();
  const user = useAppSelector((state) => state.user);
  const currentRegionId = user.region?.id;
  const loadbalancerRegions = user.services
    .filter((service) => service.code === ServiceCode.loadbalancer)
    .map((service) => service.regionId);

  if (currentRegionId && loadbalancerRegions.includes(currentRegionId)) {
    return <Outlet />;
  }

  const availableRegions = loadbalancerRegions.map((regionId) => user.regions.find((region) => region.id === regionId)?.name || '');

  return (
    <PageLayout title={t('loadbalancer.self')}>
      <h2 className="font-sub-heading mb-0" qa-element="loadbalancer">{t('loadbalancer.self')}</h2>
      <ServiceUnavailable serviceName={t('loadbalancer.self')} availableRegions={availableRegions} />
    </PageLayout>
  );
};

export default LoadbalancerLayout;
